import { colorTokens } from '../theme/tokens'

// Naive `NButton` colour props for the Prompt Library's primary actions
// (Add prompt / Save). The library belongs to the factory (agent work), so
// its primary action is amber rather than the app-wide mint `type="primary"`.
// The ink is a near-black amber for ≥ 7:1 contrast on the fill.
export const PROMPT_FACTORY_INK = '#241606'

export const promptFactoryButtonProps = {
  color: colorTokens.factory,
  textColor: PROMPT_FACTORY_INK,
} as const
